import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CTabs, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CRow, CCol,
    CButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import Loading from 'src/containers/_loading';
import { ThePermission } from '../ThePermission';
import Housing from 'src/views/housings/Housing';
import { housingActions, fileActions, provinceActions, employeeActions } from 'src/_actions';
import { helps } from 'src/_helpers';
import { NotesContainer } from '../notes';
import { FilesContainer } from '../files';
import { TasksComponentContainer } from '../tasks/TasksComponentContainer';
import { HousingRecordsContainer } from './DocRecordsContainer';
import { AssetsComponentContainer } from '../assets/AssetsComponentContainer';


class DocContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            housing: {},
            object: 'housings',
        }
    }

    componentDidMount() {
        this.getEmployees();

        this.getHousings().then(housings => {
            this.getHousing().then(() => {
                this.getFiles().then((files) => {
                    var housing = this.state.housing;
                    housing['files'] = files;
                    this.setState({ housing: housing });
                });
            });
        });

    }

    async getHousing() {
        let housing_id = this.props.match.params.id;
        const { housings, provinces } = this.props;
        var housing = {};
        if (housing_id && housings) {
            let housing = helps.getItemFromArr(housings, housing_id);
            var province = helps.getItemFromArr(provinces, housing.province_id);
            housing['province'] = province.name;
            this.setState({ housing: housing });
        }
        return housing;
    }

    async getFiles() {
        if (!helps.isEmpty(this.state.housing)) {
            const files = await this.props.getFiles('housings', this.state.housing.id);

            return files;
        }
    }

    async getHousings() {
        return await this.props.getAll('all');
    }

    async getUsers() {
        const { users } = this.props;
        if (helps.isEmpty(users)) await this.props.getUsers();
    }

    async getEmployees() {
        const { employees } = this.props;
        if (helps.isEmpty(employees)) await this.props.getEmployees();
    }

    render() {
        if (this.props.loading) {
            return (
                <Loading></Loading>
            );
        }
        if (helps.isEmpty(this.props.housings)) {
            return (
                <Loading></Loading>
            );
        }
        if (helps.isEmpty(this.state.housing)) {
            return (
                <Loading></Loading>
            );
        }
        const housing = this.state.housing;
        return (
            <ThePermission {... this.props} component="housings" action="view">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol md={7} sm={12} className='mb-2'>
                                Nhà Đội: <b>{housing.name}{housing.tax_number && <> - {housing.tax_number}</>}</b>
                                {housing.address && <div><small className='text-muted' style={{ fontSize: '13px' }}><CIcon name="cil-location-pin"></CIcon> <i>{housing.address}</i></small></div>}
                            </CCol>
                            <CCol md={5} sm={12} className='mb-2 text-right'>
                                <ThePermission {... this.props} component="housings" action="edit">
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        title="Chỉnh Sửa"
                                        onClick={() => { this.props.history.push(`/housings/add_edit/${housing.id}`) }}
                                    >
                                        <CIcon name="cil-pen-nib" className="mfe-1 mt-0"></CIcon>
                                        Chỉnh Sửa Nhà Đội
                                    </CButton>
                                </ThePermission>
                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CTabs activeTab="info">
                            <CNav variant="tabs">
                                <CNavItem>
                                    <CNavLink data-tab="info">
                                        <h6>Thông Tin</h6>
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink data-tab="records">
                                        <h6>Lưu Trú</h6>
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink data-tab="tasks">
                                        <h6>Công Việc</h6>
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink data-tab="assets">
                                        <h6>Bàn Giao / Thu Hồi</h6>
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink data-tab="notes">
                                        <h6>Ghi Chú</h6>
                                    </CNavLink>
                                </CNavItem>
                                <CNavItem>
                                    <CNavLink data-tab="files">
                                        <h6>Tài Liệu</h6>
                                    </CNavLink>
                                </CNavItem>
                            </CNav>
                            <CTabContent className="py-3">
                                <CTabPane data-tab="info">
                                    <Housing {... this.props} housing={housing} />
                                </CTabPane>
                                <CTabPane data-tab="records">
                                    <HousingRecordsContainer {... this.props} housing={housing} />
                                </CTabPane>
                                <CTabPane data-tab="tasks">
                                    <TasksComponentContainer {... this.props} object={this.state.object} object_id={housing.id} />
                                </CTabPane>
                                <CTabPane data-tab="assets">
                                    <AssetsComponentContainer {... this.props} object='housing' object_data={housing} />
                                </CTabPane>
                                <CTabPane data-tab="notes">
                                    <NotesContainer {... this.props} object={this.state.object} object_id={housing.id} />
                                </CTabPane>
                                <CTabPane data-tab="files">
                                    <FilesContainer {... this.props} object={this.state.object} object_id={housing.id} />
                                </CTabPane>
                            </CTabContent>
                        </CTabs>
                    </CCardBody>
                </CCard>

            </ThePermission >

        );
    }
}

function mapStateToProps(state) {
    const { loading, housings } = state.housingReducer;
    const { users } = state.userReducer;
    const { provinces } = state.provinceReducer;
    const { notes } = state.noteReducer;
    const { files } = state.fileReducer;
    const { employees } = state.employeeReducer;
    return { loading, housings, users, notes, files, provinces, employees };
}

const actionCreators = {
    getAll: housingActions.getAll,
    updateHousing: housingActions.update,
    getProvinces: provinceActions.getAll,
    uploadFile: fileActions.uploadFile,
    deleteFile: fileActions.deleteFile,
    getFiles: fileActions.getAll,
    getEmployees: employeeActions.getAll,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(DocContainer);
export { connectedContainer as DocContainer };